<template>
  <div class="container">
    <h1>{{ titulo }}</h1>
    <form>
      <div class="modal-body">
        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="linha"
            >Linha:</label
          >
          <select class="form-control" id="avisos-card" v-model="payload.linha">
            <option
              v-for="linha in linhas"
              v-bind:value="linha.value"
              v-bind:key="linha.value"
            >
              {{ linha.nome }}
            </option>
          </select>
        </div>
        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="ordem"
            >Ordem:</label
          >
          <select class="form-control" id="avisos-card" v-model="payload.ordem">
            <option
              v-for="ordem in ordens"
              v-bind:value="ordem.value"
              v-bind:key="ordem.value"
            >
              {{ ordem.nome }}
            </option>
          </select>
        </div>
        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="tituloPequeno"
            >Título Curto:</label
          >
          <input
            type="text"
            id="tituloPequeno"
            class="form-control validate"
            v-model="payload.tituloPequeno"
          />
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="texto"
            >Texto:</label
          >
          <input
            type="text"
            id="texto"
            class="form-control validate"
            v-model="payload.texto"
          />
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="titulo"
            >Título:</label
          >
          <input
            type="text"
            id="titulo"
            class="form-control validate"
            v-model="payload.titulo"
          />
        </div>

        <div class="md-form" data-focus="false">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="lead"
            >Lead:</label
          >
          <ckeditor
            :editor="editor"
            v-model="payload.lead"
            :config="editorConfig"
            id="lead"
            class="form-control validate"
          ></ckeditor>
        </div>

        <div class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="lead"
            >Imagens:</label
          >
          <input
            type="file"
            multiple
            label="Selecione as imagens"
            @change="adicionarImagem($event)"
          />
        </div>

        <div v-for="topico in payload.topicos" v-bind:key="topico.topicoId">
          <div class="md-form">
            <i class="fas fa-user prefix grey-text"></i>
            <label data-error="wrong" data-success="right" for="lll"
              >Tópico:</label
            >
            <input
              type="text"
              :id="topico.topico"
              class="form-control validate"
              v-model="topico.topico"
            />
          </div>

          <div class="md-form">
            <i class="fas fa-user prefix grey-text"></i>
            <label data-error="wrong" data-success="right" for="fff"
              >Texto:</label
            >
            <ckeditor
              :editor="editor"
              v-model="topico.texto"
              :config="editorConfig"
              id="fff"
              class="form-control validate"
            ></ckeditor>
          </div>
        </div>

        <div class="md-form">
          <button
            id="card_adicionar_topico"
            class="btn btn-unique"
            @click="adicionarTopico"
          >
            Adicionar Tópico <i class="fas fa-paper-plane-o ml-1"></i>
          </button>
        </div>

        <div>
          <label for="avisar" class="form-check-label">Avisar?</label>
          <select
            class="form-control"
            id="avisos-card"
            v-model="payload.avisos"
          >
            <option
              v-for="aviso in tiposDeAvisos"
              v-bind:value="aviso.identifier"
              v-bind:key="aviso.identifier"
            >
              {{ aviso.value }}
            </option>
          </select>
        </div>

        <div>
          <input
            type="checkbox"
            id="cardRestito"
            class="form-check-input validate"
            v-model="payload.restrito"
          />
          <label for="cardRestito" class="form-check-label">Restrito?</label>
        </div>

        <div v-if="erroCadastrarCard" class="md-form">
          <span>Erro ao cadastrar Card</span>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-unique" type="submit" @click="cadastrarCard">
          {{ textoBotao }} <i class="fas fa-paper-plane-o ml-1"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { cardAPI } from "@/modules/home";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { POSITION, TYPE } from "vue-toastification";

export default {
  computed: {
    ...mapGetters(["token"]),
    titulo() {
      if (this.payload.cardId) {
        return "Editar Card";
      }
      return "Cadastrar Card";
    },
    textoBotao() {
      if (this.payload.cardId) {
        return "Atualizar";
      }
      return "Cadastrar";
    },
  },
  name: "app",
  props: {
    payload: {
      type: Object,
      default: {
        topicos: [{ topico: "", texto: "", imagens: [] }],
        imagens: [],
        restrito: false,
        avisos: 0,
      },
    },
  },
  data() {
    return {
      topicoAdicionado: false,
      imagemAdicionada: false,
      topicoImagemAdicionada: false,
      editor: ClassicEditor,
      editorData: "<p>Digite aqui!</p>",
      editorConfig: {
        link: {
          addTargetToExternalLinks: true,
        },
      },
      linhas: [
        { nome: "Atuação do Produtor", value: 1 },
        { nome: "Agricultura Sustentável", value: 2 },
      ],
      ordens: [
        { nome: "1", value: 1 },
        { nome: "2", value: 2 },
        { nome: "3", value: 3 },
        { nome: "4", value: 4 },
      ],
      erros: [],
      erroCadastrarCard: false,
      tiposDeAvisos: [
        { identifier: 1, value: "Comprador" },
        { identifier: 2, value: "Produtor" },
        { identifier: 3, value: "Todos" },
        { identifier: 0, value: "Ninguém" },
      ],
      errosHeaders: {
        avisos: "Avisar",
        ordem: "Ordem",
        titulo: "Titulo",
        tituloPequeno: "Titulo Curto",
        texto: "Texto",
        linha: "Linha",
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    adicionarTopico() {
      const topico = {
        topico: "",
        texto: "",
        imagens: [],
      };

      this.payload.topicos.push(topico);
      this.topicoAdicionado = true;
    },
    validate() {
      this.erros = [];
      console.log("this.payload: ", this.payload);
      Object.keys(this.payload).map((payload) => {
        if (
          !Array.isArray(this.payload[payload]) &&
          !this.payload[payload] &&
          payload !== "restrito" &&
          payload !== "avisos" &&
          payload !== "showCard" &&
          this.payload === "ordem" &&
          this.payload[payload] < 0
        ) {
          this.erros.push(`Campo ${this.errosHeaders[payload]} é obrigatório`);
        }
      });

      return !!this.erros.length;
    },
    cadastrarCard() {
      if (!this.validate()) {
        this.setLoading(true);

        const formData = new FormData();

        if (this.imagemAdicionada) {
          for (let i = 0; i < this.payload.imagens.length; i++) {
            formData.append("imagens", this.payload.imagens[i]);
          }
        }
        if (this.payload.cardId) {
          formData.append("cardId", this.payload.cardId);
        }
        formData.append("tituloPequeno", this.payload.tituloPequeno);
        formData.append("texto", this.payload.texto);
        formData.append("titulo", this.payload.titulo);
        formData.append("lead", this.payload.lead);
        formData.append("restrito", this.payload.restrito);
        formData.append("ordem", this.payload.ordem);
        formData.append("linha", this.payload.linha);
        formData.append("avisos", this.payload.avisos);

        for (let i = 0; i < this.payload.topicos.length; i++) {
          if (this.payload.topicos[i].cardTopicoId) {
            formData.append(
              "topicos[" + i + "].cardId",
              this.payload.topicos[i].cardId
            );
            formData.append(
              "topicos[" + i + "].cardTopicoId",
              this.payload.topicos[i].cardTopicoId
            );
          }
          formData.append(
            "topicos[" + i + "].topico",
            this.payload.topicos[i].topico
          );
          formData.append(
            "topicos[" + i + "].texto",
            this.payload.topicos[i].texto
          );
        }

        this.erroCadastrarCard = false;
        const promisse = this.payload.cardId
          ? cardAPI.update(formData)
          : cardAPI.create(formData);

        promisse
          .then((resp) => {
            this.setLoading(false);
            this.payload = {
              topicos: [],
              imagens: [],
            };
            this.$toast("Card cadastrado com sucesso", {
              timeout: 2000,
              hideProgressBar: true,
            });
            window.location.reload();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.erroCadastrarCard = true;
            this.$toast("Erro ao cadastrar card", {
              timeout: 2000,
              hideProgressBar: true,
              position: POSITION.BOTTOM_RIGHT,
              type: TYPE.ERROR,
            });
          });
      } else {
        this.erros.forEach((item) => {
          this.$toast(item, {
            timeout: 2000,
            hideProgressBar: true,
            position: POSITION.BOTTOM_RIGHT,
            type: TYPE.ERROR,
          });
        });
      }
    },
    adicionarImagem(event) {
      this.payload.imagens = event.target.files;
      this.imagemAdicionada = true;
    },
    adicionarImagemTopico(event, topico) {
      topico.imagens = event.target.files;
      this.topicoImagemAdicionada = true;
    },
  },
};
</script>
